import { createGetEndpoint, getQueryString } from '@sonar-software/sonar-http';
import { KeyPaginationQueryParams, PaginatedResource, SonarSortDirection } from '@sonar-software/sonar-ts-types';
import { TimelineBaseRequest, TimelineTableEntry } from '@types';

export type TimelineDetailsTableColumnKey = 'changeType' | 'displayName' | 'modifiedBy' | 'sonarObjectType' | 'date';

export type GetTimelineDetailsRequest = TimelineBaseRequest & KeyPaginationQueryParams & {
	sortBy?: TimelineDetailsTableColumnKey;
	sortDirection?: SonarSortDirection;
};

export type GetTimelineDetailsResponse = PaginatedResource<TimelineTableEntry>;

export const getTimelineDetails = createGetEndpoint<GetTimelineDetailsRequest, GetTimelineDetailsResponse>(
	(request) => `/api/v3/timelines/details?${getQueryString(request)}`
);
